// extracted by mini-css-extract-plugin
module.exports = {"header":"_93444fe79c--header--tHyuy","wrapper":"_93444fe79c--wrapper--nvKdW","content":"_93444fe79c--content--PnMkN"};